import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PoolFilterService {
  private readonly API_URL = `${environment.apiUrl}/pool-filter`;

  constructor(private http: HttpClient) {}

  getPoolFilter(): Observable<any> {
    return this.http.get<any>(this.API_URL);
  }

  updatePoolFilter(filterJson: string): Observable<any> {
    return this.http.put<any>(this.API_URL, filterJson);
  }
}